module.exports = __webpack_public_path__ + "static/media/pulverizador2.8b0ca215.svg";